import presbDesk from '../../../../../assets/images/brand-pages/presbyopia/presbyopia-desktop.jpg';
import presbMob from '../../../../../assets/images/brand-pages/presbyopia/presbyopia-mobile.jpg';
import astDesk from '../../../../../assets/images/brand-pages/astigmatism/astigmatism-desktop.jpg';
import astMob from '../../../../../assets/images/brand-pages/astigmatism/astigmatism-mobile.jpg';
import myoDesk from '../../../../../assets/images/brand-pages/myopia/myopia-desktop.jpg';
import myoMob from '../../../../../assets/images/brand-pages/myopia/myopia-mobile.jpg';

export const images = {
  presbyopia: [presbMob, presbDesk],
  astigmatism: [astMob, astDesk],
  myopia: [myoMob, myoDesk],
};
